import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { showSnackBar } from '../../components/Snackbar/Snackbar'
import { clearListCache } from '../../utils/listCache'

const IDLE = { pending: false, title: '', message: null, thunk: null, success: '' }

const useTeamMemberAction = ({ onSuccess } = {}) => {
  const dispatch = useDispatch()
  const [state, setState] = useState(IDLE)
  const [busy, setBusy] = useState(false)
  const inFlightRef = useRef(false)

  const request = ({ title, message, thunk, success }) => {
    if (busy || !thunk) return
    setBusy(true)
    setState({ pending: true, title, message, thunk, success })
  }

  const confirm = async () => {
    if (!state.pending || inFlightRef.current) return
    const { thunk, success } = state
    inFlightRef.current = true
    setState(IDLE)

    try {
      const response = await dispatch(thunk)
      if (response.error) {
        showSnackBar('error', response.payload)
      } else {
        showSnackBar('success', success)
        clearListCache('affiliates')
        onSuccess?.(response.payload?.data)
      }
    } finally {
      inFlightRef.current = false
      setBusy(false)
    }
  }

  const cancel = () => {
    if (inFlightRef.current) return
    setState(IDLE)
    setBusy(false)
  }

  return {
    request,
    confirm,
    cancel,
    pending: state.pending,
    title: state.title,
    message: state.message,
    busy,
  }
}

export default useTeamMemberAction
